<template>
  <div class="btn-group">
    <button
      title="Exportar dados"
      type="button"
      class="btn btn-info dropdown-toggle"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
    >
      <font-awesome-icon :icon="'file-download'"></font-awesome-icon>
      <span class="caret"></span>
    </button>
    <ul class="dropdown-menu">
      <li v-for="item in types" :key="item.value">
        <a v-on:click.stop.prevent="imprimir(item.value)" class="link-export">
          <span>
            <font-awesome-icon :icon="item.icon"></font-awesome-icon>
            <span class="icon-space">{{ item.value }}</span>
          </span>
          <font-awesome-icon :icon="item.downloadIcon"></font-awesome-icon>
        </a>
      </li>
    </ul>
  </div>
</template>
<style scoped>
.icon-space {
  margin-left: 5px;
}
ul.dropdown-menu > li > a {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}
</style>

<script>
import { request } from '@/request'
export default {
  name: 'print-table',
  data() {
    return {
      types: [
        { value: 'pdf', icon: 'file-pdf', downloadIcon: 'download' },
        { value: 'csv', icon: 'file-csv', downloadIcon: 'download' },
        { value: 'xls', icon: 'file-excel', downloadIcon: 'download' }
      ]
    }
  },
  props: {
    apiUrl: {
      type: String,
      required: true
    },
    fields: {
      type: Array,
      required: true
    },
    appendParams: Object,
    title: {
      type: String,
      default: 'Listagem'
    }
  },
  methods: {
    imprimir(extension) {
      const { appendParams, fields, apiUrl, title } = this
      const link = document.createElement('a')
      let retorno = {}
      let href = ''

      if (extension === 'csv') {
        return this.convertToCSV()
      }

      fields
        .filter(field => field.visible)
        .forEach(item => (retorno[item.name] = item.title))

      const params = `${JSON.stringify(retorno)}/${JSON.stringify(title)}`
      const token = JSON.parse(localStorage.getItem('daUser')).token
      href = `${apiUrl}/${extension}/${params}?token=${token}`

      if (appendParams) href += `&${window.jQuery.param(appendParams)}`

      link.href = href
      link.click()
    },
    async convertToCSV() {
      const { apiUrl, title } = this
      const filename = `${title.replaceAll(' ', '')}.csv`
      const token = JSON.parse(localStorage.getItem('daUser')).token

      const {
        data: { total }
      } = await request.get(`${apiUrl}?token=${token}&page=1&per_page=1`)
      const response = await request.get(
        `${apiUrl}?token=${token}&page=1&per_page=${total}`
      )

      const headers = this.getHeaders()
      const rows = this.getRows(headers, response.data.data)

      let csv = [headers.map(item => item.title).join(';')]
      rows.forEach(row => csv.push(row.join(';')))

      let csvStr = csv.join('\r\n')
      var downloadLink = document.createElement('a')
      var blob = new Blob(['\ufeff', csvStr])
      var url = URL.createObjectURL(blob)
      downloadLink.href = url
      downloadLink.download = filename

      document.body.appendChild(downloadLink)
      downloadLink.click()
      document.body.removeChild(downloadLink)
    },
    getHeaders() {
      const { fields } = this

      return fields
        .filter(item => item.name != '__slot:actions' && item.visible)
        .map(field => {
          return field.hasOwnProperty('columnName')
            ? { name: field.columnName, title: field.title }
            : { name: field.name, title: field.title }
        })
    },
    getRows(headers, data) {
      const rows = data.map(item => {
        return headers.map(({ name }) => {
          let value = item[name]

          if (typeof value === 'boolean') {
            value = value ? 'Sim' : 'Não'
          }

          return value
        })
      })

      return rows
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/PrintTable.vue